import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Preis = props => (
  <SvgIcon {...props} viewBox="0 0 48 48">
    <g fill="none" fillRule="evenodd">
      <circle fill="#FFA86A" cx="24" cy="24" r="24" />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M28 31l2.29-2.29-4.88-4.88-4 4L14 20.41 15.41 19l6 6 4-4 6.3 6.29L34 25v6z"
      />
    </g>
  </SvgIcon>
);

export default Preis;
